import { alpha, Box, Button, Typography } from '@mui/material'
import { isGuest } from '../../../../helpers'
import { useStoreActions, useStoreState } from '../../../../store/hooks'

export const GuestBlocker = () => {
    const setOverlayTrigger = useStoreActions((state) => state.setOverlayTrigger)
    const userData = useStoreState((state) => state.userData)

    const guest = isGuest(userData.userData?.groups)
    if (!guest) return null

    return (
        <>
            <Box
                id="guest-blocker-backdrop"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000,
                    display: 'flex',
                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.9),
                    backdropFilter: 'blur(2px)',
                    opacity: 0.8,
                    pointerEvents: 'none',
                }}
            ></Box>
            <Box
                id="guest-blocker"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1001,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    overflow: 'scroll',
                    margin: '0 auto',
                    alignItems: 'center',
                    maxWidth: '650px',
                    filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))',
                }}
            >
                <Typography variant="h5" textAlign="center" paragraph>
                    HEY! LOOKS LIKE YOU <br /> HAVEN’T SIGNED IN YET!
                </Typography>
                <Typography variant="body1" textAlign="center" paragraph>
                    Discover the latest chess news and updates at your fingertips!
                    <br />
                    Sign up and unlock access to all premium and exclusive features!
                </Typography>
                <Button variant="contained" size="large" color="primary" onClick={() => setOverlayTrigger('signup')}>
                    Sign Up
                </Button>
                <Typography variant="body1" textAlign="center" mt={2} paragraph>
                    Already have an account?
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    textAlign="center"
                    onClick={() => setOverlayTrigger('signin')}
                >
                    Sign in
                </Typography>
            </Box>
        </>
    )
}
